import type {
  InitGameOptions,
  MemoryFeastBowl,
  MemoryFeastPlayerId,
  MemoryFeastState,
} from "./types";
import { MEMORY_FEAST_BOWL_COUNT, MEMORY_FEAST_PLAYERS } from "./types";

export function createBowls(): readonly MemoryFeastBowl[] {
  return Array.from({ length: MEMORY_FEAST_BOWL_COUNT }, (_unused, id) => ({
    id,
    count: 0,
    open: false,
  }));
}

export function initGame(options: InitGameOptions = {}): MemoryFeastState {
  const firstPlayerId: MemoryFeastPlayerId = options.firstPlayerId ?? "p1";
  return {
    gameId: options.gameId ?? `memory-feast-${MEMORY_FEAST_PLAYERS.join("-")}`,
    players: MEMORY_FEAST_PLAYERS.map((playerId) => ({
      playerId,
      label: playerId === "p1" ? "선" : "후",
    })),
    phase: "place",
    bowls: createBowls(),
    round: 1,
    firstPlayerId,
    currentPlayerId: firstPlayerId,
    moveNumber: 0,
    lastOpen: null,
    winnerId: null,
    lastAction: null,
  };
}
